import { AuthSideContentProps } from './types';

export const AuthSideContent = ({ children }: AuthSideContentProps) => (
    <div className="relative bg-info md:bg-auth-img bg-center bg-cover bg-no-repeat max-md:rounded-b-xl flex-1 flex flex-col items-center px-4 pt-4 md:pt-16 xl:pt-12 pb-6 max-md:before:absolute max-md:before:inset-0 max-md:before:bg-white max-md:before:-z-1">
        <div className="w-full lg:w-3/4 max-md:max-w-96 sticky top-6 md:bg-[hsl(0_0%_100%/.95)] rounded-xl md:mx-4 md:px-12 xl:px-16 md:pt-8 xl:pt-12 md:pb-12 xl:pb-16">
            {children}
        </div>
    </div>
);
